var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["type", "external", "className", "children", "href", "to", "obfuscate", "obflinkProps"], _excluded2 = ["target", "onClick"];
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import * as React from "react";
import { Link as ReactRouterLink, useHistory } from "react-router-dom";
import classNames from "classnames";
import { linkCls, linkTypeDefault, linkTypeStrong, linkTypeLight } from "./Link.less";
var TYPES = {
  DEFAULT: "default",
  STRONG: "strong",
  LIGHT: "light"
};
var TYPE_TO_CLASSNAME = _defineProperty(_defineProperty(_defineProperty({}, TYPES.DEFAULT, linkTypeDefault), TYPES.STRONG, linkTypeStrong), TYPES.LIGHT, linkTypeLight);
var Link = /* @__PURE__ */ __name(function Link2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? TYPES.DEFAULT : _ref$type, _ref$external = _ref.external, external = _ref$external === void 0 ? false : _ref$external, className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$href = _ref.href, href = _ref$href === void 0 ? null : _ref$href, _ref$to = _ref.to, to = _ref$to === void 0 ? null : _ref$to, _ref$obfuscate = _ref.obfuscate, obfuscate = _ref$obfuscate === void 0 ? false : _ref$obfuscate, _ref$obflinkProps = _ref.obflinkProps, obflinkProps = _ref$obflinkProps === void 0 ? null : _ref$obflinkProps, restProps = _objectWithoutProperties(_ref, _excluded);
  var history = useHistory();
  var ComponentType = external ? "a" : ReactRouterLink;
  if (obfuscate) {
    var DEFAULT_OBFLINK_PROPS = {
      component: "span",
      stopPropagation: false
    };
    var target = restProps.target, _onClick = restProps.onClick, restObfProps = _objectWithoutProperties(restProps, _excluded2);
    var _DEFAULT_OBFLINK_PROP = _objectSpread(_objectSpread({}, DEFAULT_OBFLINK_PROPS), obflinkProps), Component = _DEFAULT_OBFLINK_PROP.component, stopPropagation = _DEFAULT_OBFLINK_PROP.stopPropagation;
    return (
      // $FlowFixMe
      /* @__PURE__ */ React.createElement(
        Component,
        _extends({
          role: "link"
        }, restObfProps, {
          onClick: /* @__PURE__ */ __name(function onClick(e) {
            if (typeof _onClick === "function") {
              _onClick(e);
              if (stopPropagation) {
                return;
              }
            }
            if (external || target) {
              window.open(href || to, target);
            } else {
              history.push(href || to);
            }
          }, "onClick"),
          className: classNames(linkCls, type && TYPE_TO_CLASSNAME[type], className)
        }),
        children
      )
    );
  }
  return /* @__PURE__ */ React.createElement(ComponentType, _extends({}, restProps, external ? {
    href: href || to
  } : {
    to: to || href
  }, {
    className: classNames(linkCls, type && TYPE_TO_CLASSNAME[type], className)
  }), children);
}, "Link");
export {
  Link
};
